//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MapNavigationType',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    image: {
      type: String,
      default: () => require('@/assets/images/default-image.svg')
    }
  }
}
